export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};



// WEBPACK FOOTER //
// ./src/ReduxStore/Utility.js